/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router
/** layout.base: 具有公共部分的布局，如全局头部、侧边栏、底部等
 *  layout.baseVariant: 另一个公共页面样式
 *  layout.blank: 空白布局
 *  view.[RouteKey]: 页面组件
 */
import { $t } from '@/locales';

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      title: '403',
      i18nKey: 'route.403',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.blank$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.blank$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'application',
    path: '/application',
    component: 'layout.base',
    meta: {
      title: 'application',
      i18nKey: 'route.5',
      localIcon: 'bookmark-star-outline-rounded',
      order: 5,
      menuId: ['5']
    },
    children: [
      {
        name: 'application_develop',
        path: '/application/develop',
        component: 'view.application_develop',
        meta: {
          title: 'application_develop',
          i18nKey: 'route.5_20',
          order: 1,
          menuId: ['20'],
          pageTitle: 'route.5_20'
        }
      }
    ]
  },
  {
    name: 'client',
    path: '/client',
    component: 'layout.base',
    meta: {
      title: 'client',
      i18nKey: 'route.3',
      localIcon: 'settings-rounded',
      order: 3,
      menuId: ['3']
    },
    children: [
      {
        name: 'client_management',
        path: '/client/management',
        component: 'view.client_management',
        meta: {
          title: 'client_management',
          i18nKey: 'route.3_13',
          order: 1,
          menuId: ['13'],
          pageTitle: 'route.3_13'
        }
      },
      {
        name: 'client_management-add',
        path: '/client/management-add',
        component: 'view.client_management-add',
        meta: {
          title: 'client_management-add',
          i18nKey: 'route.client_management-add',
          hideInMenu: true,
          activeMenu: 'client_management',
          menuId: ['13'],
          pageTitle: 'page.client.create'
        }
      },
      {
        name: 'client_management-edit',
        path: '/client/management-edit',
        component: 'view.client_management-edit',
        meta: {
          title: 'client_management-edit',
          hideInMenu: true,
          i18nKey: 'route.client_management',
          activeMenu: 'client_management',
          menuId: ['13'],
          pageTitle: 'route.client_management-edit'
        }
      },
      {
        name: 'client_platform',
        path: '/client/platform',
        component: 'view.client_platform',
        meta: {
          title: 'client_platform',
          i18nKey: 'route.3_14',
          order: 2,
          menuId: ['14'],
          hideInMenu: true
        }
      }
    ]
  },
  {
    name: 'data',
    path: '/data',
    component: 'layout.blank',
    meta: {
      title: 'data',
      i18nKey: 'route.6',
      localIcon: 'bid-landscape-outline-rounded',
      order: 6,
      menuId: ['6']
    },
    children: [
      {
        name: 'data_all-screen',
        path: '/data/all-screen',
        component: 'view.data_all-screen',
        meta: {
          title: 'data_all-screen',
          i18nKey: 'route.6_21',
          order: 1,
          menuId: ['21']
        }
      },
      {
        name: 'data_app-chart',
        path: '/data/app-chart',
        component: 'view.data_app-chart',
        meta: {
          title: 'data_app-chart',
          i18nKey: 'route.6_23',
          order: 3,
          menuId: ['23'],
          pageTitle: 'route.6_23'
        }
      },
      {
        name: 'data_product-chart',
        path: '/data/product-chart',
        component: 'view.data_product-chart',
        meta: {
          title: 'data_product-chart',
          i18nKey: 'route.6_22',
          order: 2,
          menuId: ['22']
        }
      }
    ]
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      title: 'home',
      i18nKey: 'route.1',
      localIcon: 'home-rounded',
      order: 1,
      menuId: ['1']
    }
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|reset-pwd)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'product',
    path: '/product',
    component: 'layout.base',
    meta: {
      title: 'product',
      i18nKey: 'route.4',
      localIcon: 'terminal-rounded',
      order: 4,
      menuId: ['4']
    },
    children: [
      {
        name: 'product_debug',
        path: '/product/debug',
        component: 'view.product_debug',
        meta: {
          title: 'product_debug',
          i18nKey: 'route.4_18',
          order: 4,
          menuId: ['18'],
          pageTitle: 'route.4_18'
        }
      },
      {
        name: 'product_debug-add',
        path: '/product/debug-add',
        component: 'view.product_debug-add',
        meta: {
          title: 'product_debug-add',
          i18nKey: 'route.product_debug-add',
          activeMenu: 'product_debug',
          hideInMenu: true,
          menuId: ['18'],
          pageTitle: 'route.product_debug-add'
        }
      },
      {
        name: 'product_debug-detail',
        path: '/product/debug-detail',
        component: 'view.product_debug-detail',
        meta: {
          title: 'product_debug-detail',
          i18nKey: 'route.product_debug-detail',
          activeMenu: 'product_debug',
          hideInMenu: true,
          menuId: ['18'],
          pageTitle: 'route.product_debug-detail'
        }
      },
      {
        name: 'product_develop',
        path: '/product/develop',
        component: 'view.product_develop',
        meta: {
          title: 'product_develop',
          i18nKey: 'route.4_15',
          order: 1,
          menuId: ['15'],
          pageTitle: 'route.4_15'
        }
      },
      {
        name: 'product_develop-add',
        path: '/product/develop-add',
        component: 'view.product_develop-add',
        meta: {
          title: 'product_develop-add',
          i18nKey: 'route.product_develop-add',
          activeMenu: 'product_develop',
          hideInMenu: true,
          menuId: ['15'],
          pageTitle: 'route.product_develop-add'
        }
      },
      {
        name: 'product_develop-detail',
        path: '/product/develop-detail',
        component: 'view.product_develop-detail',
        meta: {
          title: 'product_develop-detail',
          i18nKey: 'route.product_develop-detail',
          activeMenu: 'product_develop',
          hideInMenu: true,
          menuId: ['15'],
          pageTitle: 'route.product_develop-detail'
        }
      },
      {
        name: 'product_develop-lang',
        path: '/product/develop-lang',
        component: 'view.product_develop-lang',
        meta: {
          title: 'product_develop-lang',
          i18nKey: 'route.product_develop-lang',
          activeMenu: 'product_develop',
          hideInMenu: true,
          menuId: ['15'],
          pageTitle: 'route.product_develop-lang'
        }
      },
      {
        name: 'product_device',
        path: '/product/device',
        component: 'view.product_device',
        meta: {
          title: 'product_device',
          i18nKey: 'route.4_16',
          order: 2,
          menuId: ['16'],
          pageTitle: 'route.4_16'
        }
      },
      {
        name: 'product_device-detail',
        path: '/product/device-detail',
        component: 'view.product_device-detail',
        meta: {
          hideInMenu: true,
          title: 'product_device-detail',
          i18nKey: 'route.product_device-detail',
          activeMenu: 'product_device',
          pageTitle: 'route.product_device-detail'
        }
      },
      {
        name: 'product_firmware',
        path: '/product/firmware',
        component: 'view.product_firmware',
        meta: {
          title: 'product_firmware',
          i18nKey: 'route.4_17',
          order: 3,
          menuId: ['17'],
          pageTitle: 'route.4_17'
        }
      },
      {
        name: 'product_firmware-add',
        path: '/product/firmware-add',
        component: 'view.product_firmware-add',
        meta: {
          hideInMenu: true,
          title: 'product_firmware-add',
          i18nKey: 'route.product_firmware-add',
          menuId: ['17'],
          activeMenu: 'product_firmware',
          pageTitle: 'route.product_firmware-add'
        }
      },
      {
        name: 'product_firmware-list',
        path: '/product/firmware-list',
        component: 'view.product_firmware-list',
        meta: {
          hideInMenu: true,
          title: 'product_firmware-list',
          i18nKey: 'route.product_firmware-list',
          menuId: ['17'],
          activeMenu: 'product_firmware',
          pageTitle: 'route.product_firmware-list'
        }
      },
      {
        name: 'product_firmware-task-detail',
        path: '/product/firmware-task-detail',
        component: 'view.product_firmware-task-detail',
        meta: {
          hideInMenu: true,
          title: 'product_firmware-task-detail',
          i18nKey: 'route.product_firmware-task-detail',
          menuId: ['17'],
          activeMenu: 'product_firmware',
          pageTitle: 'route.product_firmware-task-detail'
        }
      },
      {
        name: 'product_log',
        path: '/product/log',
        component: 'view.product_log',
        meta: {
          title: 'product_log',
          i18nKey: 'route.4_19',
          order: 5,
          menuId: ['19'],
          pageTitle: 'route.4_19'
        }
      }
    ]
  },
  {
    name: 'system',
    path: '/system',
    component: 'layout.base',
    meta: {
      title: 'system',
      i18nKey: 'route.2',
      localIcon: 'family-history-outline-rounded',
      order: 2,
      menuId: ['2']
    },
    children: [
      {
        name: 'system_account',
        path: '/system/account',
        component: 'view.system_account',
        meta: {
          title: 'system_account',
          i18nKey: 'route.2_7',
          order: 1,
          menuId: ['7'],
          pageTitle: 'route.2_7'
        }
      },
      {
        name: 'system_account-add',
        path: '/system/account-add',
        component: 'view.system_account-add',
        meta: {
          title: 'system_account-add',
          i18nKey: 'route.system_account-add',
          hideInMenu: true,
          activeMenu: 'system_account',
          menuId: ['7'],
          pageTitle: 'route.system_account-add'
        }
      },
      {
        name: 'system_account-permission',
        path: '/system/account-permission',
        component: 'view.system_account-permission',
        meta: {
          title: 'system_account-permission',
          i18nKey: 'route.system_account-permission',
          hideInMenu: true,
          activeMenu: 'system_account',
          menuId: ['7'],
          pageTitle: 'route.system_account-permission'
        }
      },
      {
        name: 'system_application-template',
        path: '/system/application-template',
        component: 'view.system_application-template',
        meta: {
          title: 'system_application-template',
          i18nKey: 'route.2_10',
          order: 4,
          menuId: ['10'],
          pageTitle: 'route.2_10'
        }
      },
      {
        name: 'system_category',
        path: '/system/category',
        component: 'view.system_category',
        meta: {
          title: 'system_category',
          i18nKey: 'route.2_9',
          order: 3,
          menuId: ['9'],
          pageTitle: 'route.2_9'
        }
      },
      {
        name: 'system_category-add',
        path: '/system/category-add',
        component: 'view.system_category-add',
        meta: {
          title: 'system_category-add',
          i18nKey: 'route.system_category-add',
          activeMenu: 'system_category',
          hideInMenu: true,
          menuId: ['9'],
          pageTitle: 'route.system_category-add'
        }
      },
      {
        name: 'system_category-detail',
        path: '/system/category-detail',
        component: 'view.system_category-detail',
        meta: {
          title: 'system_category-detail',
          i18nKey: 'route.system_category-detail',
          activeMenu: 'system_category',
          hideInMenu: true,
          menuId: ['9'],
          pageTitle: 'route.system_category-detail'
        }
      },
      {
        name: 'system_firmwaretype',
        path: '/system/firmwaretype',
        component: 'view.system_firmwaretype',
        meta: {
          title: 'system_firmwaretype',
          i18nKey: 'route.system_firmwaretype',
          order: 6,
          menuId: ['24'],
          pageTitle: 'route.system_firmwaretype'
        }
      },
      {
        name: 'system_firmwaretype-lang',
        path: '/system/firmwaretype-lang',
        component: 'view.system_firmwaretype-lang',
        meta: {
          title: 'system_firmwaretype-lang',
          i18nKey: 'route.system_firmwaretype-lang',
          hideInMenu: true,
          menuId: ['24'],
          pageTitle: 'page.firmwareType.lang'
        }
      },
      {
        name: 'system_menu',
        path: '/system/menu',
        component: 'view.system_menu',
        meta: {
          title: 'system_menu',
          i18nKey: 'route.2_12',
          order: 5,
          menuId: ['12'],
          pageTitle: 'route.2_12'
        }
      },
      {
        name: 'system_menu-lang',
        path: '/system/menu-lang',
        component: 'view.system_menu-lang',
        meta: {
          title: 'system_menu-lang',
          i18nKey: 'route.system_menu-lang',
          hideInMenu: true,
          menuId: ['12'],
          pageTitle: 'page.menu.menuLang'
        }
      },
      {
        name: 'system_role',
        path: '/system/role',
        component: 'view.system_role',
        meta: {
          title: 'system_role',
          i18nKey: 'route.2_8',
          order: 2,
          menuId: ['8'],
          pageTitle: 'route.2_8'
        }
      }
    ]
  },
  {
    name: 'user',
    path: '/user',
    component: 'layout.baseVariant',
    meta: {
      title: 'user',
      i18nKey: 'route.user',
      hideInMenu: true,
      menuId: ['1'],
      constant: true
    },
    children: [
      {
        name: 'user_center',
        path: '/user/center',
        component: 'view.user_center',
        meta: {
          title: 'user_center',
          i18nKey: 'route.user_center',
          pageTitle: 'route.user_center',
          menuId: ['1']
        }
      },
      {
        name: 'user_company',
        path: '/user/company',
        component: 'view.user_company',
        meta: {
          title: 'user_company',
          i18nKey: 'route.user_company',
          pageTitle: 'route.user_company',
          menuId: ['1']
        }
      },
      {
        name: 'user_reset-email',
        path: '/user/reset-email',
        component: 'view.user_reset-email',
        meta: {
          title: 'user_reset-email',
          i18nKey: 'route.user_reset-email',
          pageTitle: 'route.user_reset-email',
          menuId: ['1']
        }
      },
      {
        name: 'user_reset-password',
        path: '/user/reset-password',
        component: 'view.user_reset-password',
        meta: {
          title: 'user_reset-password',
          i18nKey: 'route.user_reset-password',
          pageTitle: 'route.user_reset-password',
          menuId: ['1']
        }
      }
    ]
  }
];
